import { createSelector } from 'reselect';
import { actionKey } from './constants';
function getSlice(state) {
    return state[actionKey] || {
        fileUploads: [],
        fileUploadsWaiting: [],
        fileUploadsCompleted: []
    };
}
export const getUploads = createSelector(getSlice, (slice)=>slice.fileUploads);
export const getUploadsWaiting = createSelector(getSlice, (slice)=>slice.fileUploadsWaiting);
export const getAllUploads = createSelector(getUploads, getUploadsWaiting, (uploads, uploadsWaiting)=>[
        ...uploads,
        ...uploadsWaiting
    ]);
export const getCompletedUploads = createSelector(getSlice, (slice)=>slice.fileUploadsCompleted);
export const getUploadById = createSelector(getAllUploads, (state, fileId)=>fileId, (allUploads, fileId)=>allUploads.find((fu)=>fu.fileId === fileId));
export const getUploadsByTag = createSelector(getAllUploads, (state, tag)=>tag, (allUploads, tag)=>allUploads.filter((fu)=>fu.tag === tag));
